import { FC, InputHTMLAttributes } from 'react';
import { UseFormRegister } from 'react-hook-form';
import clsx from 'clsx';
import { cvaAltInput, cvaInput } from '~/shared/ui/AltInput/AltInputStyles';
import InputMask from 'react-input-mask';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  register?: UseFormRegister<any>;
  required?: boolean;
  error?: boolean;
  mask?: string;
  maskChar?: string;
  formatChars?: object;
  altInput?: boolean;
}

const MAX_KEYBOARD_PROPORTION = 0.52;
const preventScrollWhenSoftKeyboardAppearsIfThereIsPlentyOfRoom = (e) => {
  // Bail if not iOS
  if (!/iPad|iPhone|iPod/.test(navigator.userAgent)) return;
  // Bail if there's too little vertical space and scrolling is necessary
  if (
    (e.target.offsetTop + e.target.offsetHeight) / window.innerHeight >
    MAX_KEYBOARD_PROPORTION
  )
    return;

  // Fix the position of the body momentarily to prevent user agent scrolling
  let offset = document.body.scrollTop;
  document.body.style.top = offset * -1 + 'px';
  document.body.classList.add('prevent-ios-focus-scrolling');
  setTimeout(() => {
    // Undo it after 500ms, roughly the amount of time focus animation takes iOS
    offset = parseInt(document.body.style.top, 10);
    document.body.classList.remove('prevent-ios-focus-scrolling');
    document.body.scrollTop = offset * -1;
  }, 500);
  //console.log('hello');
};

export const AltInput: FC<Props> = ({
  register,
  name,
  required,
  className,
  maskChar,
  formatChars,
  altInput = true,
  ...rest
}) => {
  const currentStyle = altInput ? cvaAltInput() : cvaInput();

  return (
    <InputMask
      {...rest}
      id={name}
      onFocus={preventScrollWhenSoftKeyboardAppearsIfThereIsPlentyOfRoom}
      maskChar={maskChar ?? ' '}
      formatChars={formatChars}
      {...(register && register(name, { required: required }))}
      className={clsx(currentStyle, className)}
    />
  );
};
